import { CommentAnnotationElement } from './ui'

import { AnnotationPlugin } from '@st/document-viewer-kit'
import { CommentAnnotation } from '@st/sdk'
import { CommentToolState } from '~/st-doc-viewer/annotations'
import { CommentToolOverlay } from './ui'

export function commentToolPlugin(): AnnotationPlugin<CommentAnnotation, CommentToolState> {
  return {
    name: 'comment',
    initialToolState: {
      name: 'comment',
      text: '',
      settings: {}
    },
    ToolOverlay: CommentToolOverlay,
    Element: CommentAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'comment',
    onAnnotationDeselected: (event, send) => {
      if (event.annotationDraft && event.annotationDraft.content == '') {
        send({ type: 'discardAnnotationDraft', annotationId: event.annotationDraft.id })
      } else if (event.annotationDraft) {
        send({ type: 'updateAnnotation', annotationDraft: event.annotationDraft })
      }
    }
  }
}
